import { type ISupportUserQuery } from 'application/querySchemas/ISupportUserQuery';
import { type ISupportUserTokenRepository } from 'application/repositorySchemas/ISupportUserTokenRepository';
import { type ISupporterCheckTokenClient } from 'interfaceAdapter/gatewaySchemas/ISupporterCheckTokenClient';
import { inject, injectable } from 'tsyringe';

@injectable()
export class SupportUserQuery implements ISupportUserQuery {
    constructor(
        @inject('ISupportUserTokenRepository')
        public readonly token: ISupportUserTokenRepository,
        @inject('ISupporterCheckTokenClient')
        public readonly checkTokenClient: ISupporterCheckTokenClient,
    ) {}

    public checkToken = async (incrementLoginCount: boolean): Promise<any> => {
        const token = this.token.get();
        if (!token) {
            return {
                user: null,
                status: false,
            };
        }
        const { data, status } = await this.checkTokenClient.get({
            token,
            addLoginCount: incrementLoginCount,
        });
        return {
            user: data,
            status: status === 'valid',
        };
    };
}
